export const ensureAbsoluteUrl = (url: string): string =>
  /^https?:\/\//i.test(url) ? url : `https://${url}`;
